import React, { use } from 'react';
import { useTranslation } from 'react-i18next';
import CheckIcon from '@mui/icons-material/Check';
import Close from '@mui/icons-material/Close';
import LinkOutlined from '@mui/icons-material/LinkOutlined';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';

import ElectronicClientRecordProviderContext from '../../providers/contexts/electronic-client-record-context';
import LinkRoomTable from './components/link-room-table/link-room-table';
import useLinkRoomModal from './hooks/link-room-hook';
import styles from './link-room-modal.module.scss';

const LinkRoomModal = (): React.JSX.Element => {
  const { t } = useTranslation('organisation', { keyPrefix: 'electronicClientRecord.linkRoomModal' });
  const { isModalOpen, onClose, handleOnLinkRoomButtonClicked, handleOnLinkRoomModalButtonClicked, isLinkRoomModalButtonDisabled } =
    useLinkRoomModal();
  const { selectedTableRoom } = use(ElectronicClientRecordProviderContext);

  return (
    <>
      <Button
        disabled={isLinkRoomModalButtonDisabled()}
        startIcon={<LinkOutlined />}
        variant="outlined"
        onClick={handleOnLinkRoomModalButtonClicked}
        data-testid="linkDeviceButton"
      >
        {t('linkRoomButtonText')}
      </Button>
      <Dialog
        open={isModalOpen}
        onClose={onClose}
        className={styles.organisationDetailsLinkRoomModal}
        slotProps={{
          paper: { classes: { root: styles.linkRoomPaper } },
        }}
      >
        <div className={styles.linkRoomModalContainer}>
          <div className={styles.linkRoomHeaderContainer}>
            <Typography className={styles.headerTitle} variant="h3">
              {t('title')}
            </Typography>
            <div className={styles.linkRoomHeaderActionsContainer}>
              <Button
                onClick={(): void => handleOnLinkRoomButtonClicked(selectedTableRoom)}
                disabled={!selectedTableRoom}
                className="link-button"
                variant="contained"
                startIcon={selectedTableRoom ? <CheckIcon className="check-icon" /> : undefined}
              >
                {t('linkButtonText')}
              </Button>

              <Divider orientation="vertical" flexItem className={styles.actionsDivider} />

              <IconButton aria-label="close" className={styles.closeButton} onClick={onClose}>
                <Close />
              </IconButton>
            </div>
          </div>
          <LinkRoomTable />
        </div>
      </Dialog>
    </>
  );
};

export default LinkRoomModal;
